import { memo, VFC, useState } from 'react';
import { useSearchParams  } from "react-router-dom";
import { NoticeDetailDialog } from '../organisms/modal/NoticeDetailDialog';

export const NoticeDetail: VFC = memo(() => {
  const [ searchParams ] = useSearchParams();
  const [ noticeId, setNoticeId ] = useState(searchParams.get('noticeId'));
  
  return (
    <>
    {noticeId && (
      <NoticeDetailDialog
        noticeId={noticeId}
        setNoticeId={setNoticeId}
        direct={true}
      />
    )}
    </>
  );
});